import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import 'react-toastify/dist/ReactToastify.css';
import ToastContainer from './index_style';
import './index.css';
import App from './App';
import store from './store';

const THIRTY_SECONDS = 30000;

const reloadOnChunkFailure = () => {
  const lastReload = Number(sessionStorage.getItem('vite-preload-reloaded-at') ?? '0');
  const now = Date.now();

  if (now - lastReload > THIRTY_SECONDS) {
    sessionStorage.setItem('vite-preload-reloaded-at', String(now));
    window.location.reload();
  }
};

window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  reloadOnChunkFailure();
});

window.addEventListener('unhandledrejection', (event) => {
  const message = String(event.reason?.message ?? event.reason ?? '');

  if (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed') ||
    message.includes('error loading dynamically imported module')
  ) {
    event.preventDefault();
    reloadOnChunkFailure();
  }
});

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
      <ToastContainer />
    </BrowserRouter>
  </Provider>,
);
